<template>
    <div class="px-2">   
        <!-- <h5 class="text-center blue darken-4 py-2">
            <b class="white--text"> Oferta academica </b>
        </h5> -->
        <v-row class="mt-1">
            <v-col xs="2" sm="2" md="3" lg="2">
                <v-btn small class="ma-0" @click="$router.back()" color="info" outlined> 
                    <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
                </v-btn>
            </v-col>
            <v-col xs="2" sm="1" v-if="ver_todas_sedes">
                <v-checkbox v-model="omitir_sede" color="blue" label="omitir sede" outlined dense :loading="loading"> </v-checkbox>
            </v-col>
            <v-col xs="2" sm="1">
                <v-btn color="blue" small outlined dark :loading="loading" @click="getDatos()"> <v-icon>mdi-refresh</v-icon> </v-btn>
            </v-col>
            <v-col xs="6" sm="4"> 
                <p class="my-0"> Sede: <b> {{ $store.state.CARGO.sede.nombre }} </b> </p> 
                <!-- <p class="my-0"> Mes: <b> ? </b> </p>  -->
            </v-col>
            <!-- <v-col v-if="isgestionar" xs="6" sm="5" md="3" class="text-right">
                <v-btn small class="mr-2 elevation-0" @click="$router.push('/oferta_autoria')" color="info" tile> 
                    <v-icon>mdi-account</v-icon> gestionar
                </v-btn>
            </v-col> -->
        </v-row>
        <v-divider class="mt-2 mb-4" />  

        <v-tabs v-model="tab" align-with-title dark background-color="primary darken-3">
            <v-tabs-slider color="green"></v-tabs-slider>
            <v-tab>Seleccionados</v-tab>
            <v-tab>Listas de seleccion</v-tab> 
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item  >
                <autoriaSeleccionados ref="refautoriaSeleccionados" /> 
            </v-tab-item>
            <v-tab-item  >
                <v-btn color="blue" small outlined dark :loading="loading" @click="descargarListas()">Descargar listas xlsx</v-btn>
                <autoriaSede ref="refautoriaSede" v-on:onsuccessseleccionado="getDatos" />
                <autoriaLibre ref="refautoriaLibre" v-on:onsuccessseleccionado="getDatos" />
                <autoriaEstrella ref="refautoriaEstrella" v-on:onsuccessseleccionado="getDatos" />
            </v-tab-item>
        </v-tabs-items>


    </div>
</template>
  
<script>
import autoriaSeleccionados from './autoria-seleccionados.vue';
import autoriaSede from './autoria-sede.vue';
import autoriaLibre from './autoria-libre.vue';
import autoriaEstrella from './autoria-estrella.vue';
import { exportarAExcel } from './toexcel';

export default {
    components: {autoriaSeleccionados,autoriaSede,autoriaLibre,autoriaEstrella}, 
    data() {
        return {
            loading: false,    
            txt: '', 
            isgestionar: false,
            omitir_sede: false,
            ver_todas_sedes: false,
            // tabs
            tab: null, 
        };
    }, 
    methods: {
        async getDatos(){
            this.$refs.refautoriaSeleccionados.getDatos(this.omitir_sede);
            if(this.$refs.refautoriaSede) this.$refs.refautoriaSede.getDatos();
            if(this.$refs.refautoriaLibre) this.$refs.refautoriaLibre.getDatos();
            if(this.$refs.refautoriaEstrella) this.$refs.refautoriaEstrella.getDatos();
        },  

        descargarListas(){
            const d1 = this.$refs.refautoriaSede.getRows()
            const d2 = this.$refs.refautoriaLibre.getRows()
            const d3 = this.$refs.refautoriaEstrella.getRows()
            const datos = d1.concat(d2).concat(d3)

            
            window.console.log('>>>');
            window.console.log(d1);
            window.console.log(d2);
            window.console.log(d3);
            window.console.log('>>>');
            exportarAExcel(datos)
            
        }

    },
    mounted() {
        const cid = this.$store.state.CARGO.id;
        const uid = this.$store.state.DATA_USER.id;
        this.isgestionar = cid == 1 || cid == 5 || uid == 35886 || uid == 59716;
        this.ver_todas_sedes = cid == 1 || cid == 5 || uid == 35886 || uid == 59716;
    },
};
</script>
  